import React from 'react';
import { Button, Container, Form, Row, Col } from 'react-bootstrap';

import { IntrashBackend } from './backend';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


export class LoginPage extends React.Component {
    constructor(props) {
        super(props);
  
        this.state = {
            username: "",
            password: "",
            showInvalidCredentialsMessage: false
        };
    }

    handleLogIn(user) {
        if (user === undefined || user === null) {
            this.setState({ username: "", password: "", showInvalidCredentialsMessage: true });
        }
        else {
            this.props.onLogIn(user);
        }
    }
    
    handleSubmit(e) {
        IntrashBackend.login(this.state.username, this.state.password).then(user => { this.handleLogIn(user) })
        e.preventDefault();
    }

    render() {
        return (
            <Container fluid>
            <Form onSubmit={(e) => this.handleSubmit(e)}>
                <Form.Group>
                    <Form.Label>Username</Form.Label>
                    <Form.Control type="text" placeholder="Username" value={this.state.username} onChange={(e) => this.setState({ username: e.target.value })}/>
                </Form.Group>
                <Form.Group>
                    <Form.Label>Password</Form.Label>
                    <Form.Control type="password" placeholder="Password" value={this.state.password} onChange={(e) => this.setState({ password: e.target.value })}/>
                </Form.Group>
                <Button variant="primary" type="submit">
                    Submit
                </Button>
            </Form>
            <Row>
                <Col/>
                <Col xs="auto">
                    <h4 hidden={!this.state.showInvalidCredentialsMessage} style={{ color: "indianred" }}>Invalid Credentials</h4>
                </Col>
                <Col/>
            </Row>
            </Container>
        );
    }
}